<template>
    <div class="desired-load-container">
        <h6 class="font-semibold text-base text-black mt-10 mb-4">Your desired loan amount</h6>
        <div class="flex justify-between items-end font-semi-bold">
            <div class="text-black leading-none text-7xl">{{ amount }}</div>
            <div class=" text-black leading-none text-3xl">USD</div>
        </div>
        <LineDivider />
    </div>
</template>

<script>
export default {
    name: 'DesiredLoan',
    components: {
        LineDivider: () => import('./GlobalLineDivider.vue')
    },
    props: {
        amount: {
            type: String,
            required: true,
        }
    },
    data() {
        return {
            
        }
    },
}
</script>